export const DEFAULT_COLOR = 'var(--color-brand-main)';
export const DEFAULT_LINE_COLORS = ['var(--color-brand-main)', 'var(--border-color-info-intense)'];
export const DEFAULT_HEIGHT = 150;
export const DEFAULT_WIDTH: number | string = '100%';
export const DEFAULT_DECIMALS = 2;
export const DEFAULT_FONT_FAMILY = 'Inter, ui-sans-serif, system-ui';
export const DEFAULT_FORE_COLOR = 'var(--text-color-light)';
export const AREA_YAXIS_COLOR = 'var(--bg-color-neutral-inverse-strong)';
export const LINE_YAXIS_COLOR = 'var(--bg-color-neutral-inverse-strong)';
export const XAXIS_LABEL_COLOR = 'var(--text-color-light)';
export const DEFAULT_VARIANT = 'line';

export const RESPONSIVE_BREAKPOINTS = [
    { breakpoint: 350, options: { xaxis: { tickAmount: 2 } } },
    { breakpoint: 600, options: { xaxis: { tickAmount: 4 } } },
    { breakpoint: 960, options: { xaxis: { tickAmount: 6 } } },
    { breakpoint: 1600, options: { xaxis: { tickAmount: 8 } } },
] as const;

export const LINE_TOOLTIP_FONT_SIZE = '12px';
